import { useState } from 'react';
import { MenuItem, TextField, KeyboardDatePicker, GridItem } from 'seagull';
import { useIoContext, useStoreActions } from "../../contexts";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
const autoprefix = 'agreement-studio-datepicker';
var EffectiveDateType = /*#__PURE__*/function (EffectiveDateType) {
  EffectiveDateType["UponApproval"] = "uponApproval";
  EffectiveDateType["SpecificDate"] = "specificDate";
  return EffectiveDateType;
}(EffectiveDateType || {});
export default function AgreementStudioDatePickerPanel(props) {
  const {
    value,
    disabled,
    onChange,
    fullWidth = false,
    className
  } = props;
  const ioContext = useIoContext();
  const {
    logBI
  } = useStoreActions();
  const [dateType, setDateType] = useState(value ? EffectiveDateType.SpecificDate : EffectiveDateType.UponApproval);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs(GridItem, {
      span: fullWidth ? 12 : 9,
      className: className,
      children: [/*#__PURE__*/_jsx(TextField, {
        select: true,
        SelectProps: {
          style: {
            textAlign: 'left'
          }
        },
        fullWidth: fullWidth,
        name: "hasEffectiveDate",
        value: dateType,
        disabled: disabled,
        onChange: function (_onChange) {
          function onChange(_x) {
            return _onChange.apply(this, arguments);
          }
          onChange.toString = function () {
            return _onChange.toString();
          };
          return onChange;
        }(_ref => {
          let {
            target
          } = _ref;
          setDateType(target.value);
          if (target.value === EffectiveDateType.UponApproval) {
            logBI(10465);
            onChange(null);
          } else {
            const effectiveDate = value || ioContext.getNow();
            logBI(10468, {
              date: effectiveDate.toString()
            });
            onChange(effectiveDate);
          }
        }),
        label: "Agreement effective date",
        "data-testid": 'agreement-studio-effective-date-picker',
        children: [{
          value: EffectiveDateType.UponApproval,
          label: 'On acceptance',
          testId: 'on-approval'
        }, {
          value: EffectiveDateType.SpecificDate,
          label: 'On a specific date',
          testId: 'specific-date'
        }].map(_ref2 => {
          let {
            value,
            label,
            testId
          } = _ref2;
          return /*#__PURE__*/_jsx(MenuItem, {
            value: value,
            "data-testid": "agreement-studio-effective-date-picker-option-".concat(testId),
            children: label
          }, value);
        })
      }), /*#__PURE__*/_jsx("div", {
        hidden: value == null,
        children: /*#__PURE__*/_jsx(KeyboardDatePicker, {
          fullWidth: fullWidth,
          "data-testid": autoprefix,
          KeyboardButtonProps: {
            'aria-label': 'change date'
          },
          disabled: dateType === EffectiveDateType.UponApproval || disabled,
          value: value,
          onChange: function (_onChange2) {
            function onChange(_x2) {
              return _onChange2.apply(this, arguments);
            }
            onChange.toString = function () {
              return _onChange2.toString();
            };
            return onChange;
          }(date => {
            if (date) {
              onChange(date);
              logBI(10468, {
                date: date.toString()
              });
            }
          })
        })
      })]
    }), /*#__PURE__*/_jsx(GridItem, {
      span: fullWidth ? 0 : 3
    })]
  });
}